module.exports = __webpack_public_path__ + "img/PrimaryHealingFullyRestoredBone.b73d2e1b.jpg";